/**
 * Shared time off types for API contracts
 */
import { z } from "zod";
// ===== ENUMS =====
/**
 * Time off type values as a const array for z.enum
 */
export const TimeOffTypeValues = [
    "PTO",
    "VACATION",
    "SICK",
    "PERSONAL",
    "OTHER",
    "UNPAID",
];
/**
 * Zod schema for time off type
 */
export const TimeOffTypeSchema = z.enum(TimeOffTypeValues);
/**
 * Enum-like object for dot-access syntax (e.g., TimeOffType.PTO).
 * Used throughout seed data, tests, and services.
 */
export const TimeOffType = {
    PTO: "PTO",
    VACATION: "VACATION",
    SICK: "SICK",
    PERSONAL: "PERSONAL",
    OTHER: "OTHER",
    UNPAID: "UNPAID",
};
// ===== INPUT SCHEMAS =====
/**
 * Schema for creating a time off request (with approval workflow)
 * Note: requesterId and companyId come from JWT, not request body
 */
export const CreateTimeOffRequestInputSchema = z.object({
    startTime: z.iso.datetime(),
    endTime: z.iso.datetime(),
    timeOffType: TimeOffTypeSchema,
    notes: z.string().trim().max(1000).optional(),
    comment: z.string().trim().max(1000).optional(), // For approval request
});
/**
 * Schema for creating time off directly (admin override, no approval)
 * Note: companyId comes from JWT, not request body
 */
export const CreateTimeOffInputSchema = z.object({
    employeeId: z.uuid(),
    startTime: z.iso.datetime(),
    endTime: z.iso.datetime(),
    timeOffType: TimeOffTypeSchema,
    notes: z.string().trim().max(1000).optional(),
    approved: z.boolean().optional(),
});
/**
 * Schema for updating time off
 */
export const UpdateTimeOffInputSchema = z.object({
    startTime: z.iso.datetime().optional(),
    endTime: z.iso.datetime().optional(),
    timeOffType: TimeOffTypeSchema.optional(),
    notes: z.string().trim().max(1000).optional(),
    approved: z.boolean().optional(),
    deducted: z.boolean().optional(),
});
// ===== RESPONSE SCHEMAS =====
/**
 * Schema for time off response
 */
export const TimeOffResponseSchema = z.object({
    id: z.uuid(),
    employeeId: z.uuid(),
    companyId: z.uuid(),
    startTime: z.iso.datetime(),
    endTime: z.iso.datetime(),
    timeOffType: TimeOffTypeSchema,
    notes: z.string().optional(),
    approved: z.boolean(),
    deducted: z.boolean(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
